import { candidateRequests } from "api/candidateApi";
import React from "react";
import { ReferenceInput, required, SelectInput } from "react-admin";
import { CitizenshipIds } from "utils/constants";

const ForeignerCampaignCandidates = ({ handleParamChange }) => {
  return (
    <>
      <ReferenceInput
        label="Кампания"
        source="campaignId"
        reference={candidateRequests.getCampaignsSelect()}
        filter={{ citizenshipIds: [CitizenshipIds.EuForeigners, CitizenshipIds.NotEuForeigners] }}
      >
        <SelectInput
          validate={required()}
          label="Кампания"
          optionText="nameBg"
          onChange={e => handleParamChange("campaignId", e.target.value)}
        />
      </ReferenceInput>
    </>
  );
};

export default ForeignerCampaignCandidates;
